import { FC } from 'react'

import { Route, Switch } from 'react-router-dom'

import { ResourceErrorBoundary } from 'core/resources'

import { ByoTwilioDetail } from './resources/ByoTwilio'
import {
  CreditAgenciesList,
  CreditAgencyCreate,
  CreditAgencyDetail,
} from './resources/CreditAgencies'
import {
  EmployeeCreate,
  EmployeeDetail,
  EmployeesList,
} from './resources/Employees'
import { KeyCreate, KeyDetail, KeysList } from './resources/Keys'
import { LoanTypeDetail, LoanTypesList } from './resources/LoanTypes'
import {
  MonitoringServiceDetail,
  MonitoringServicesList,
} from './resources/MonitoringServices'
import { UserCreate, UserDetail, UsersList } from './resources/Users'

const base = '/companies/:companyId'

const EnginePilotRoutes: FC = () => (
  <ResourceErrorBoundary>
    <Switch>
      <Route exact path={`${base}/keys`}>
        <KeysList />
      </Route>
      {/* Declared before /keys/:keyId so 'create' is not read as an id. */}
      <Route exact path={`${base}/keys/create`}>
        <KeyCreate />
      </Route>
      <Route path={`${base}/keys/:keyId`}>
        <KeyDetail />
      </Route>

      <Route exact path={`${base}/monitoring/services`}>
        <MonitoringServicesList />
      </Route>
      <Route path={`${base}/monitoring/services/:serviceId`}>
        <MonitoringServiceDetail />
      </Route>

      <Route path={`${base}/byo-twilio`}>
        <ByoTwilioDetail />
      </Route>

      <Route exact path={`${base}/credit-agencies`}>
        <CreditAgenciesList />
      </Route>
      <Route exact path={`${base}/credit-agencies/create`}>
        <CreditAgencyCreate />
      </Route>
      <Route path={`${base}/credit-agencies/:creditAgencyId`}>
        <CreditAgencyDetail />
      </Route>

      <Route exact path={`${base}/employees`}>
        <EmployeesList />
      </Route>
      <Route exact path={`${base}/employees/create`}>
        <EmployeeCreate />
      </Route>
      <Route path={`${base}/employees/:employeeId`}>
        <EmployeeDetail />
      </Route>

      <Route exact path={`${base}/users`}>
        <UsersList />
      </Route>
      <Route exact path={`${base}/users/create`}>
        <UserCreate />
      </Route>
      <Route path={`${base}/users/:userId`}>
        <UserDetail />
      </Route>

      <Route exact path={`${base}/loan-types`}>
        <LoanTypesList />
      </Route>
      <Route path={`${base}/loan-types/:loanTypeId`}>
        <LoanTypeDetail />
      </Route>
    </Switch>
  </ResourceErrorBoundary>
)

export default EnginePilotRoutes
